/**
 * Domain models and API contracts for the Home screen.
 *
 * The backend wraps every payload in `{ status, response }`, so `ApiResponse<T>`
 * captures that envelope and `T` describes the actual data shape.
 */

export interface ApiResponse<T> {
  status: number;
  response: T;
}

export interface Category {
  id: number;
  title: string;
}

export interface Course {
  id: number;
}

/** Map of `category.id` -> first course returned for that category. */
export type CoursesByCategory = Record<number, Course>;

export interface MostViewedVideo {
  id: number;
  title: string;
  description: string;
  thumbnail: string;
  course: { id: number };
}

export interface OtpRequestResponse {
  uuid: string;
}

export interface SubscribeResponse {
  token: string;
  subscribeId: string;
}

export interface FormError {
  Error: string;
  isTrue: boolean;
}

export const EMPTY_FORM_ERROR: FormError = { Error: "", isTrue: false };
